export default {
  Validate: {
    FieldIsNotAllowEmpty: 'Không được bỏ trống.',
    InvalidEmailAddress: 'Định dạng email không hợp lệ.',
    InvalidPhoneNumber: 'Định dạng số điện thoại không hợp lệ.',
    FieldValueIsLessThanMinValue:
      'Giá trị của ô này không được nhỏ hơn {minValue}.',
    FieldValueIsGreaterThanMaxValue:
      'Giá trị của ô này không được lớn hơn {maxValue}.',
    FieldValueIsNotBetweenMinAndMaxValue:
      'Giá trị của ô này phải lớn hơn hoặc bằng {minValue} và nhỏ hơn hoặc bằng {maxValue}.',
    ClassCodeIsNotAllowEmpty:
      'Mã lớp không được để trống.',
    InvalidClassCode:
      'Mã lớp chưa chính xác.',
    NeedInputEnoughtCharacters: 'Bạn phải nhập đủ {characters} kí tự',
    InputValidStringPlease: 'Vui lòng nhập các giá trị từ a-z, 0-9',
    DoNotExitSISAPCode: 'Mã SISAP không tồn tại.'
  }
}
